// src/api/api.js
import axios from 'axios'
import { useAuthStore } from '@/stores/auth'
import router from "@/router";

const api = axios.create({
    baseURL: '/api/',
    headers: { 'Content-Type': 'application/json' }
})

// Добавляем токен авторизации в каждый запрос
api.interceptors.request.use(config => {
    const authStore = useAuthStore()
    if (authStore.token) {
        config.headers.Authorization = `Bearer ${authStore.token}`
    }
    return config
})

// Перехватываем ошибки
api.interceptors.response.use(
    (response) => {
        // При каждом успешном запросе обновляем токен если он скоро истечет
        const token = localStorage.getItem('token')
        if (token) {
            try {
                const payload = JSON.parse(atob(token.split('.')[1]))
                const now = Math.floor(Date.now() / 1000)
                // Если токен истекает менее чем через 2 дня, обновляем его
                if (payload.exp - now < 2 * 24 * 60 * 60) {
                    refreshToken()
                }
            } catch (e) {
                console.warn('Ошибка проверки токена:', e)
            }
        }
        return response
    },
    (error) => {
        if (error.response?.status === 401) {
            // Токен истек, очищаем данные и редиректим на логин
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            router.push('/login')
        }
        return Promise.reject(error)
    }
)
const refreshToken = async () => {
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}')
        if (user.username) {
            // Можно реализовать отдельный endpoint для refresh токена
            // Пока оставляем как есть
        }
    } catch (e) {
        console.warn('Ошибка обновления токена:', e)
    }
}

export default api
